import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { dlStyles } from '../../../styles';
import type { Package } from '../entities';

@customElement('umb-market-package-sidebar-updated-info')
export class UmbMarketPackageSidebarUpdatedInfo extends LitElement {
  @property({ type: Object })
  package?: Package;

  #getCreatedUpdatedDates() {
    if (!this.package) return null;

    return html`<div>
        <dt>Updated</dt>
        <dd>
          ${new Date(this.package.lastPublishedOn).toLocaleDateString(
            window.navigator.language,
            {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            }
          )}
        </dd>
      </div>
      <div>
        <dt>Listed on Marketplace</dt>
        <dd>
          ${new Date(this.package.createdOn).toLocaleDateString(
            window.navigator.language,
            {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            }
          )}
        </dd>
      </div>`;
  }

  #getPackageVersion() {
    if (this.package?.latestVersionNumberForProvidedUmbracoVersion) {
      return html`<div>
        <dt>Supported version</dt>
        <dd>${this.package.latestVersionNumberForProvidedUmbracoVersion}</dd>
      </div>`;
    }

    return html`<div>
      <dt>Current version</dt>
      <dd>${this.package?.latestVersionNumber}</dd>
    </div>`;
  }

  render() {
    if (this.package?.isRetired) {
      return null;
    }

    return html`<div>
      <dl>${this.#getPackageVersion()} ${this.#getCreatedUpdatedDates()}</dl>
    </div>`;
  }

  static styles = [
    dlStyles,
    css`
      :host {
        display: block;
      }
    `,
  ];
}
